import { render, staticRenderFns } from "./AbsenceNotificationModal.vue?vue&type=template&id=212ff39e"
import script from "./AbsenceNotificationModal.vue?vue&type=script&lang=ts"
export * from "./AbsenceNotificationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports